module.exports = __webpack_public_path__ + "static/media/cbse-logo.d26768ca.png";